export default {
  //@ts-ignore
  install(Vue, options) {
    Vue.mixin({
      methods: {
        //@ts-ignore
        async RefreshTheToken() {
          try {
            var response = await this.$http.post("api/user/refresh", { token: localStorage.getItem("CTC_REFRESH_TOKEN") });
            this.$store.dispatch("refresh", response.data);
            return response;
          }
          catch (err) {
            console.error(err);
            return Promise.reject(err);
          }
        }
      },
      mounted() {
        Vue.prototype.$refresh = this.RefreshTheToken
      }
    });
  }
}
